import React from "react";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useDispatch,useSelector, useStore } from "react-redux";
import { AppDispatch,RootState } from "../../services/redux/store";
import { setActiveHorizontalIndex, setActiveVerticalIndex } from "../../services/redux/slices/stepperDynamicFormSlice";
import NoProvisionalLetterIcon from "./../../assets/svgIcons/provision-failed.svg";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getCombinedApplicationSteps,
} from "../../components/ui/StepperDyanmicForm/helper";
import {
  setDisplayHorizontalSteps,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { fetchUserApplicationsFormData } from "../../services/api/service/userApplicationService";
const NoProvisionalOfferCard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
      trackingId,
    } = useSelector((state: RootState) => state.stepper);
  const handleContinue = async() => {
      localStorage.setItem("coAppId", "0");
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      const res: any = await fetchUserApplicationsFormData(
        token,
        trackingId
      );
      const apps = res.data?.applications || [];
      let finalSteps = getCombinedApplicationSteps(apps[0]);
      dispatch(setDisplayHorizontalSteps(finalSteps));
      // Clean up document_verified and consent parameters from URL
      const currentSearch = location?.search || "";
      let cleanSearch = currentSearch
        .replace(/[?&]document_verified=true/g, "")
        .replace(/[?&]consent=true/g, "");
      
      // Clean up any double ampersands or leading ampersand
      cleanSearch = cleanSearch.replace(/^\?&/, "?").replace(/^&/, "?").replace(/&&/g, "&");
      
      // If cleanSearch is just "?", remove it
      if (cleanSearch === "?") {
        cleanSearch = "";
      }
      
      const newUrl = `${window.location.pathname}${cleanSearch}`;
      navigate(newUrl, { replace: true });
      
      // Then dispatch to change the active step
      dispatch(setActiveHorizontalIndex(3));
      dispatch(setActiveVerticalIndex(0));
  };
  // Mobile view that matches the image exactly
  if (isMobile) {
    return (
      <Box
        sx={{
          backgroundColor: "rgba(0, 179, 181, 0.08)",
          borderRadius: "6px",
          border: "1px solid rgba(0, 179, 181, 1)",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          minHeight: "280px",
          mb: 2,
        }}
      >
        {/* Header Illustration Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 1,
            p: 2,
          }}
        >
          {/* Envelope Icon with Document */}
          {/* <Box
            sx={{
              width: "100px",
              height: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
              position: "relative",
            }}
          >
            <img
              src={NoProvisionalLetterIcon}
              alt="No Provisional Letter Icon"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box> */}

          <Typography
          sx={{
            mt: { xs: 0.5, sm: 1 },
            mb: { xs: 0.75, sm: 1.50 },
            fontSize: "18px", // Adjust h5 size for mobile (defaults to 2.125rem)
            // color: "#FF4C51",
            fontWeight: 600,
          }}
        >
          You're One Step Closer
        </Typography>


          {/* Main Congratulations Text */}
          <Typography
            sx={{
              fontSize: "14px",
              // color: "#FF4C51",
              fontWeight: 400,
              fontFamily: "Jost",
              lineHeight: "1.2",
            }}
          >
            To personalize your loan offer, we require a few additional details from you. Please proceed to complete the remaining sections of your application.
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              fontFamily: "Jost",
              mb: 0.5,
              lineHeight: "1.2",
            }}
          >
            Our Sales Manager will review your profile and contact you shortly to discuss the available financing options.
          </Typography>

          {/* Disclaimer Text */}
          {/* <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#5E596C",
              fontFamily: "Jost",
              lineHeight: "1.4",
              maxWidth: "90%",
            }}
          >
            Oops! It seems we don't have the right financing solution for you at
            the moment that matches your profile. Please connect with your sales
            manager for further information.
          </Typography> */}

          {/* Continue Button */}
          <Button
            variant="contained"
            onClick={handleContinue}
            sx={{
              mt: 3,
              backgroundColor: "#fec10c", // Bright yellow
              color: "#000000", // Black text
              fontSize: { xs: "12px", sm: "15px" },
              fontWeight: 700,
              fontFamily: "Jost, sans-serif",
              borderRadius: "8px",
              padding: { xs: `8px 15px`, sm: `10px 20px` },
              textTransform: "none",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                backgroundColor: "#fec10c",
                boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    );
  }

  // Desktop view - keep existing unchanged
  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2 }, // Smaller padding on small screens
        mb: 2,
        backgroundColor: "#ccf0f0",
        borderRadius: "6px",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {/* Main Content (Envelope, Congratulations, Offer Text) */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 1, sm: 2 }, // Smaller vertical padding on small screens
          px: { xs: 1, sm: 0 }, // Add some horizontal padding on small screens if text gets too wide
          width: { xs: "95%", sm: "100%" }, // Ensure content doesn't stretch full width on tiny screens
        }}
      >
        {/* Envelope Icon */}
        {/* <Box
          sx={{
            width: { xs: "80px", sm: "100px" }, // Smaller icon on small screens
            height: { xs: "80px", sm: "100px" }, // Smaller icon on small screens
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: { xs: 0.5, sm: 1 }, // Adjusted margin
          }}
        >
          <img
            src={NoProvisionalLetterIcon}
            alt="No Provisional Letter Icon"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box> */}

         <Typography
          sx={{
            mt: { xs: 0.5, sm: 1 },
            mb: { xs: 0.75, sm: 1.50 },
            fontSize: "28px", // Adjust h5 size for mobile (defaults to 2.125rem)
            fontWeight: 600,
          }}
        >
          You're One Step Closer
        </Typography>


        {/* Congratulations Text */}
        <Typography
          sx={{
            mt: { xs: 0.5, sm: 1 },
            fontSize: "22px", // Adjust h5 size for mobile (defaults to 2.125rem)
            fontWeight: 400,
          }}
        >
          To personalize your loan offer, we require a few additional details from you. Please proceed to complete the remaining sections of your application.
        </Typography>
         <Typography
          sx={{
            fontSize: "22px", // Adjust h5 size for mobile (defaults to 2.125rem)
            fontWeight: 400,
          }}
        >
          Our Sales Manager will review your profile and contact you shortly to discuss the available financing options.
        </Typography>

        {/* Disclaimer Text */}
        {/* <Typography
          sx={{
            maxWidth: { xs: "95%", sm: "80%" }, // Narrower text on small screens
            lineHeight: { xs: 1.4, sm: 1.5 },
            fontSize: { xs: "11", sm: "15px" }, // Adjust body2 size for mobile (defaults to 0.875rem)
            color: "#5E596C",
            fontWeight: 600,
          }}
        >
          Oops! It seems we don't have the right financing solution for you at
          the moment that matches your profile. Please connect with your sales
          manager for further information.
        </Typography> */}

        {/* Continue Button */}
        <Button
          variant="contained"
          onClick={handleContinue}
          sx={{
            mt: 3,
            backgroundColor: "#fec10c", // Bright yellow
            color: "#000000", // Black text
            fontSize: "15px",
            fontWeight: 700,
            fontFamily: "Jost, sans-serif",
            borderRadius: "8px",
            padding: "10px 20px",
            textTransform: "none",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: "#fec10c",
              boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
            },
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default NoProvisionalOfferCard;